import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RatioContainer from 'components/consumer/RatioContainer';
import Placeholder from 'components/consumer/Placeholder';
import usePDPPhotos from 'data-hooks/usePDPPhotos';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import PDPDesktopMarxentConfigurator from 'components/consumer/modular-configurator/PDPMarxentConfigurator';
import PDPMobileConfigurationPhotoGalleryUI from './PDPMobileConfigurationPhotoGalleryUI';
const PDPMobileConfigurationPhotoGalleryInner = t0 => {
  const $ = _c(22);
  const {
    slug,
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2,
    marxentPostHogFlag: t3,
    hideMarxent: t4,
    unavailableFabric: t5,
    hideDecideLaterOverlay: t6
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const marxentPostHogFlag = t3 === undefined ? false : t3;
  const hideMarxent = t4 === undefined ? true : t4;
  const unavailableFabric = t5 === undefined ? false : t5;
  const hideDecideLaterOverlay = t6 === undefined ? false : t6;
  const {
    loading: photosLoading,
    error: photosError,
    data: photosData
  } = usePDPPhotos(null, slug);
  const {
    loading: basicDetailsLoading,
    error: basicDetailsError,
    data: basicDetailsData
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const t7 = !pdpIsModularBYOProduct;
  let t8;
  if ($[0] !== t7) {
    t8 = {
      skip: t7
    };
    $[0] = t7;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  let modularPhotosData = useModularPDPPhotos(null, slug, t8);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    loading: cylindoLoading,
    shouldShowDimensionThumbnail,
    upholsteryKey
  } = usePDPCylindoViewer();
  const {
    resetGalleryImageTracking,
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  if (photosLoading || cylindoLoading || basicDetailsLoading || pdpIsModularBYOProduct && modularPhotosData.loading) {
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
      $[2] = t9;
    } else {
      t9 = $[2];
    }
    return t9;
  }
  if (photosError || basicDetailsError) {
    return null;
  }
  const {
    configurationPhotos,
    isConfigFlipped,
    enableCrops
  } = pdpIsModularBYOProduct ? modularPhotosData.data : photosData;
  const {
    name
  } = basicDetailsData;
  if (!configurationPhotos.length) {
    return null;
  }
  let t9;
  if ($[3] !== configurationPhotos || $[4] !== cylindoFeatures || $[5] !== enableCrops || $[6] !== hideDecideLaterOverlay || $[7] !== hideMarxent || $[8] !== isConfigFlipped || $[9] !== isCylindoAvailable || $[10] !== isEditOrder || $[11] !== marxentPostHogFlag || $[12] !== name || $[13] !== pdpIsModularBYOProduct || $[14] !== pdpSelectedCustomizerTab || $[15] !== resetGalleryImageTracking || $[16] !== shouldShowDimensionThumbnail || $[17] !== slug || $[18] !== unavailableFabric || $[19] !== upholsteryKey || $[20] !== viewGalleryImageEvent) {
    t9 = marxentPostHogFlag === "test" && pdpIsModularBYOProduct ? <PDPDesktopMarxentConfigurator pdpIsModularBYOProduct={pdpIsModularBYOProduct} slug={slug} key={slug} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} /> : <PDPMobileConfigurationPhotoGalleryUI cylindoFeatures={cylindoFeatures} enableCrops={enableCrops} isConfigFlipped={isConfigFlipped} isCylindoAvailable={isCylindoAvailable} isEditOrder={isEditOrder} photos={configurationPhotos} productName={name} showDecideLaterOverlay={!hideDecideLaterOverlay && pdpSelectedCustomizerTab === "decide-later"} resetGalleryImageTracking={resetGalleryImageTracking} viewGalleryImageEvent={viewGalleryImageEvent} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} upholsteryKey={upholsteryKey} />;
    $[3] = configurationPhotos;
    $[4] = cylindoFeatures;
    $[5] = enableCrops;
    $[6] = hideDecideLaterOverlay;
    $[7] = hideMarxent;
    $[8] = isConfigFlipped;
    $[9] = isCylindoAvailable;
    $[10] = isEditOrder;
    $[11] = marxentPostHogFlag;
    $[12] = name;
    $[13] = pdpIsModularBYOProduct;
    $[14] = pdpSelectedCustomizerTab;
    $[15] = resetGalleryImageTracking;
    $[16] = shouldShowDimensionThumbnail;
    $[17] = slug;
    $[18] = unavailableFabric;
    $[19] = upholsteryKey;
    $[20] = viewGalleryImageEvent;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
PDPMobileConfigurationPhotoGalleryInner.propTypes = {
  pdpIsModularBYOProduct: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  hideDecideLaterOverlay: PropTypes.bool,
  slug: PropTypes.string
};
const PDPMobileConfigurationPhotoGallery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RatioContainer><Placeholder type="rect" loading={true} /></RatioContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPMobileConfigurationPhotoGalleryInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPMobileConfigurationPhotoGallery;